/**
 * The "Start a Game" grid is two columns from `tablet` up (approved
 * Games-page mockup "CRITICAL RULE: ODD NUMBER OF GAME TILES"). Only the
 * *last* visible card spans both columns, and only when the visible count is
 * odd — an even count never produces a wide final card. `GameCatalogCard`'s
 * wide layout is itself gated behind `tablet:` classes, so passing `true`
 * here below that breakpoint is harmless: the card still renders as a plain
 * single-column card on mobile.
 *
 * Pulled out as its own pure function (rather than inlined at the call site)
 * so the odd/even boundary — the one thing worth getting wrong — has its own
 * unit test independent of any rendering.
 */
export function isWideCatalogCard(index: number, visibleCount: number): boolean {
  return visibleCount % 2 === 1 && index === visibleCount - 1;
}
